module.exports = __webpack_public_path__ + "18abb463ffc37b9337f34b698ed78a22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-cat-sincerely.png
// module id = 2048
// module chunks = 4